// shared/components/Pagination.jsx

import "../../styles/components/Pagination.css";

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  onPageChange,
  pageSize,
  onPageSizeChange,
  pageSizeOptions = [1,5, 10, 20, 50],
}) => {
  if (totalItems === 0) return null;

  // Build visible page buttons: always show first, last, current ±1
  const pages = buildPageRange(currentPage, totalPages);

  return (
    <div className="pg-bar">
      {/* Left: row info + optional page-size selector */}
      <div className="pg-info">
        <span className="pg-count">
          Showing&nbsp;
          <strong>{startIndex}–{endIndex}</strong>
          &nbsp;of&nbsp;
          <strong>{totalItems}</strong>
        </span>

        {onPageSizeChange && (
          <label className="pg-size-label">
            Rows&nbsp;
            <select
              className="pg-size-select"
              value={pageSize}
              onChange={(e) => onPageSizeChange(e.target.value)}
            >
              {pageSizeOptions.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </label>
        )}
      </div>

      {/* Right: prev / page buttons / next */}
      <div className="pg-controls">
        <button
          className="pg-btn pg-nav"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          ‹
        </button>

        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`ellipsis-${i}`} className="pg-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`pg-btn pg-page${p === currentPage ? " pg-active" : ""}`}
              onClick={() => onPageChange(p)}
              aria-current={p === currentPage ? "page" : undefined}
            >
              {p}
            </button>
          )
        )}

        <button
          className="pg-btn pg-nav"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          ›
        </button>
      </div>
    </div>
  );
};

/** Returns array like [1, "…", 4, 5, 6, "…", 12] */
function buildPageRange(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

  const pages = new Set([1, total, current, current - 1, current + 1]);
  const sorted = [...pages]
    .filter((p) => p >= 1 && p <= total)
    .sort((a, b) => a - b);

  const result = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) result.push("…");
    result.push(p);
  });
  return result;
}

export default Pagination;
